<template>
    <div>
        <div class="blocchetto-titolo" v-if="!this.reservationMode">
            <span><img src="/img/be/ico-pagamento.png">{{$t('carrello_mod_pagamento')}}</span>
        </div>
        <div :class="{'blocchetto-selezioni': !this.reservationMode}">
            <button type="button" class="btn btn-pagamento d-flex justify-content-between align-items-center"
                    v-for="item in this.items" @click.prevent="onItemPress(item)"
                    :class="{active: value === item.id }">
                <span v-if="item.label">
                    {{item.label}}
                </span>
                <span v-else-if="item.info">
                    <b class="text-capitalize">{{item.info.data.brand}} **** {{item.info.data.last4}}</b>
                    -
                    <span
                        :class="{'text-danger': item.info.data.expired}">
                        {{$t('scad')}} {{item.info.data.expMonth.toString().padStart(2, '0')}}/{{item.info.data.expYear}}
                    </span>
                </span>
                <a href="#" v-if="item.tipo === 'STRIPE_CARTACREDITO' && item.isFresh"
                   @click.stop.prevent="onDeletePress(item)">
                    <img src="/img/be/ico-delete-carta.png" height="20">
                </a>
                <span v-else>
                    <img :src="getIcoUrl(item)" height="30">
                </span>
            </button>
            <button type="button" class="btn btn-pagamento d-flex justify-content-between align-items-center"
                    v-if="this.is_new_card_enabled"
                    @click="onNewCardPress()">
                Aggiungi nuova carta <i class="fa fa-plus mr-2"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "IncPaymentMode",
    props: ['items', 'value', 'reservationMode'],
    computed: {
        is_new_card_enabled: function () {
            const item = this.items.find((obj) => obj.tipo === 'STRIPE_CARTACREDITO');

            return !!(item && item.info);
        }
    },
    methods: {
        getIcoUrl: function (item) {
            let imageUrl = '/img/be/';

            switch (item.tipo) {
                case 'CONTANTI':
                    switch (item.tipo_mezzo) {
                        case 'CONTANTI':
                            imageUrl += 'ico-contanti.png';
                            break;
                        case 'CARTA_CREDITO':
                            imageUrl += 'ico-pagamento-consegna.png';
                            break;
                        case 'BUONI_PASTO':
                            imageUrl += 'ico-buoni-pasto.png';
                            break;
                    }
                    break;
                case 'STRIPE_CARTACREDITO':
                    imageUrl += 'ico-carta.png';
                    break;
                case 'PAYPAL':
                    imageUrl += 'ico-paypal.png';
                    break;
            }

            return imageUrl;
        },
        onItemPress: function (item) {
            this.$emit('onItemPress', item)
        },
        onNewCardPress: function () {
            this.$emit('onNewCardPress');
        },
        onDeletePress: function (item) {
            this.$emit('onDeletePress', item);
        }
    }
}
</script>
